import LegalPageShell from '../components/LegalPageShell';

const metaDescription =
  'Terms and conditions for using the Dragon Metalworks website and engaging our steel fabrication and related services.';

export default function TermsAndConditionsPage() {
  return (
    <LegalPageShell title="Terms & Conditions" description={metaDescription}>
      <header className="legal-page-header">
        <p className="legal-page-kicker">Legal</p>
        <h1>Terms &amp; Conditions</h1>
        <p className="legal-page-updated">Last updated: April 2026</p>
      </header>

      <section className="legal-section" aria-labelledby="terms-intro">
        <h2 id="terms-intro">Introduction</h2>
        <p>
          These terms govern your use of the Dragon Metalworks website and set out the basis on which we provide
          information about our steel fabrication, supply, and installation services. By using this site you accept
          these terms. Quotations and contracts for physical work may be subject to separate written agreements.
        </p>
      </section>

      <section className="legal-section" aria-labelledby="terms-services">
        <h2 id="terms-services">Services information</h2>
        <p>
          Content on this website describes our capabilities in general terms. It does not constitute structural
          engineering advice or a binding offer until confirmed in writing. Site surveys, design input, and fabrication
          are provided subject to specification, programme, and agreed scope.
        </p>
      </section>

      <section className="legal-section" aria-labelledby="terms-quotes">
        <h2 id="terms-quotes">Quotations and pricing</h2>
        <p>
          Quotations are valid for the period stated on the quote (or, if none is stated, a reasonable period from the
          date of issue). Prices may reflect material and labour costs at the time of quotation and may be revised if
          the scope changes, delivery dates slip, or market conditions materially affect inputs.
        </p>
      </section>

      <section className="legal-section" aria-labelledby="terms-timelines">
        <h2 id="terms-timelines">Project timelines</h2>
        <p>
          Indicative lead times depend on workshop load, material availability, and coordination with your site or
          other trades. Dates are targets unless expressly agreed as fixed milestones in a signed contract.
        </p>
      </section>

      <section className="legal-section" aria-labelledby="terms-client">
        <h2 id="terms-client">Client responsibilities</h2>
        <p>
          You agree to provide accurate information, safe access for surveys and installation, and timely decisions. You
          confirm that:
        </p>
        <ul>
          <li>Drawings, loads, and interfaces supplied by others are suitable for our scope.</li>
          <li>Site conditions allow lawful delivery and installation.</li>
          <li>Necessary permissions, party-wall matters, and building control inputs are addressed as agreed.</li>
        </ul>
      </section>

      <section className="legal-section" aria-labelledby="terms-payments">
        <h2 id="terms-payments">Payments</h2>
        <p>
          Payment terms will be set out in our quotation or contract (for example, deposit, staged payments, and
          balance on completion). Late payment may affect scheduling and may incur statutory or contractually agreed
          interest where permitted.
        </p>
      </section>

      <section className="legal-section" aria-labelledby="terms-liability">
        <h2 id="terms-liability">Liability</h2>
        <p>
          Nothing in these website terms excludes or limits liability that cannot be excluded under applicable law. To
          the fullest extent permitted, we are not liable for indirect or consequential loss arising solely from use of
          this website. Liability for executed work is governed by the applicable supply and/or installation agreement
          and professional insurance arrangements.
        </p>
      </section>

      <section className="legal-section" aria-labelledby="terms-ip">
        <h2 id="terms-ip">Intellectual property</h2>
        <p>
          Text, images, branding, and layout on this website are owned by or licensed to Dragon Metalworks unless
          otherwise stated. You may not copy or reuse them for commercial purposes without our prior written consent.
        </p>
      </section>

      <section className="legal-section" aria-labelledby="terms-law">
        <h2 id="terms-law">Governing law</h2>
        <p>
          These terms are governed by the laws of England and Wales. The courts of England and Wales shall have
          non-exclusive jurisdiction, without prejudice to mandatory rights you may have elsewhere.
        </p>
      </section>

      <section className="legal-section" aria-labelledby="terms-contact">
        <h2 id="terms-contact">Contact details</h2>
        <p>
          For questions about these terms, please use the contact details in the website footer or the contact section
          of our homepage.
        </p>
      </section>
    </LegalPageShell>
  );
}
